/* eslint-disable */
import { FILTER_ADDRESS_SELECTED } from '../Filters.types';

/**
 * Action to select the address in the filters
 * @param {Array} address The address
 * @returns {ActionCreator<FromPayload<Array<string>, ActionMeta, FILTER_ADDRESS_SELECTED>>} The created `Action`
 */
const filtersSelectAddress = (address) => ({ fromPayload }) => {
  return fromPayload(address, { debounce: true }, FILTER_ADDRESS_SELECTED);
};

export default filtersSelectAddress;
